import React from "react";

const MAP = {
  active: { c: "text-emerald-400 bg-emerald-500/10 border-emerald-500/20", label: "Active" },
  pilot: { c: "text-cyan-400 bg-cyan-500/10 border-cyan-500/20", label: "Pilot" },
  trial: { c: "text-sky-400 bg-sky-500/10 border-sky-500/20", label: "Trial" },
  lead: { c: "text-slate-400 bg-slate-500/10 border-slate-500/20", label: "Lead" },
  paused: { c: "text-amber-400 bg-amber-500/10 border-amber-500/20", label: "Paused" },
  former: { c: "text-slate-500 bg-slate-700/20 border-slate-600/20", label: "Former" },
  paid: { c: "text-emerald-400 bg-emerald-500/10 border-emerald-500/20", label: "Paid" },
  unpaid: { c: "text-amber-400 bg-amber-500/10 border-amber-500/20", label: "Unpaid" },
  overdue: { c: "text-rose-400 bg-rose-500/10 border-rose-500/20", label: "Overdue" },
  connected: { c: "text-emerald-400 bg-emerald-500/10 border-emerald-500/20", label: "Connected" },
  not_connected: { c: "text-slate-400 bg-slate-500/10 border-slate-500/20", label: "Not Connected" },
  future: { c: "text-indigo-400 bg-indigo-500/10 border-indigo-500/20", label: "Coming later" },
  healthy: { c: "text-emerald-400 bg-emerald-500/10 border-emerald-500/20", label: "Healthy" },
  degraded: { c: "text-amber-400 bg-amber-500/10 border-amber-500/20", label: "Degraded" },
  stale: { c: "text-orange-400 bg-orange-500/10 border-orange-500/20", label: "Stale" },
  revoked: { c: "text-rose-400 bg-rose-500/10 border-rose-500/20", label: "Revoked" },
  mapped: { c: "text-emerald-400 bg-emerald-500/10 border-emerald-500/20", label: "Mapped" },
  manual: { c: "text-cyan-400 bg-cyan-500/10 border-cyan-500/20", label: "Manual" },
  needs_review: { c: "text-amber-400 bg-amber-500/10 border-amber-500/20", label: "Needs Review" },
  non_production: { c: "text-slate-400 bg-slate-500/10 border-slate-500/20", label: "Non-production" },
  within: { c: "text-emerald-400 bg-emerald-500/10 border-emerald-500/20", label: "Within budget" },
  approaching: { c: "text-amber-400 bg-amber-500/10 border-amber-500/20", label: "Approaching" },
  over: { c: "text-rose-400 bg-rose-500/10 border-rose-500/20", label: "Over budget" },
  cogs: { c: "text-purple-400 bg-purple-500/10 border-purple-500/20", label: "COGS" },
  opex: { c: "text-blue-400 bg-blue-500/10 border-blue-500/20", label: "OpEx" },
  fixed: { c: "text-indigo-400 bg-indigo-500/10 border-indigo-500/20", label: "Fixed" },
  variable: { c: "text-pink-400 bg-pink-500/10 border-pink-500/20", label: "Variable" },
};

export const StatusBadge = ({ status, label, testId }) => {
  const m = MAP[status] || { c: "text-slate-400 bg-slate-500/10 border-slate-500/20", label: label || status };
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-semibold capitalize ${m.c}`}>
      {label || m.label}
    </span>
  );
};

export const Money = ({ value, className = "", signed = false }) => {
  const n = Number(value || 0);
  const color = n > 0 ? "text-emerald-400" : n < 0 ? "text-rose-400" : "text-slate-300";
  return (
    <span className={`font-mono-fin ${signed ? color : "text-slate-200"} ${className}`}>
      {new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(n)}
    </span>
  );
};
